var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":require("@/assets/dennis_icon.png"),"lazy-src":require("@/assets/dennis_icon.png"),"max-width":"40","max-height":"40"}})
}
var staticRenderFns = []

export { render, staticRenderFns }